//引入外部SCSS
import '@scss/app.scss';
// import 'scss/app.scss';
//引入外部模組
import {IosFixed} from '@/common';
import {Preloader} from '@/preloader';
import {LinkEffect} from '@/link_effect';
import {FixedTools} from '@/fixed_tools';
import {NavSearch} from '@/header';
import {Search, MapSearch, ActualSearch} from '@/search_list';
import {LazyLoad} from '@/lazyload';
import {TxtCrop} from '@/txt_crop';
import {TxtZoom} from '@/txt_zoom';
import {VideoCover} from '@/index_cover';
import {IndexBanner, IndexObjsSlider, ObjsBannerImg, FooterAds} from '@/slider';
import {ParallaxBG} from '@/parallax';
import {Lightbox} from '@/lightbox.js';
import {QRcode} from '@/qrcode';
import {VR720} from '@/vr720';
import {Track} from '@/track';
import {ObjListAJAX} from '@/obj_list_ajax';
import {MapRealtyDetail, MapRealtySearch} from '@/map';
import {Mortgage2, AsideRealtyForm, ContactForm} from '@/form';
import {SameHeight} from '@/same_height';
import {Tabs, ToggleSlide} from '@/tabs';
import {Sticky} from '@/sticky';
import {TextareaAutoHeight} from '@/textarea_auto_height';
import {HeaderSearchVal, SendForm} from '@/other';
// import {Personal} from '@/personal';
import {SpeechForm} from '@/speech_form';
import {Subscription} from '@/subscription';
import swal from 'sweetalert';
// import {useRef} from '../node_modules/infinite-scroll';


//子網站
// import NewRealty from '@/new_realty/app';
// import LineAI from '@/line_ai/app';



//各頁面控制項
class NavController {
  constructor() {
    this.nav        = $('#navVal').val();
    // this.subsite    = $('#subsiteVal').val();
    // this.personalId = $('#personalIdVal').val();
  }
  //全域模組
  commonModules() {
    //使用外部模組
    let iosFixed        = new IosFixed;
    let preloader       = new Preloader;
    let linkEffect      = new LinkEffect;
    let fixedTools      = new FixedTools;
    let navSearch       = new NavSearch;
    let search          = new Search;
    let lazyLoad        = new LazyLoad;
    let lightbox        = new Lightbox;
    let qrcode          = new QRcode;
    let track           = new Track;
    // let footerAds       = new FooterAds;
    let headerSearchVal = new HeaderSearchVal;
    // let subscription    = new Subscription; //訂閱相關

    iosFixed.metaViewport();      //iOS(iPad, iPhone) Meta Viewport 鎖定縮放拖曳
    preloader.loading();          //讀取頁面
    linkEffect.effect();          //頁面淡入淡出
    fixedTools.tools();           //視窗右下角固定工具列
    navSearch.navSearch();        //Rwd 導航列 & 搜尋列
    search.searchObj();           //Search
    lazyLoad.imgLoad();           //圖片延遲載入並裁切
    lazyLoad.scrollImgLoad();     //圖片延遲載入並裁切
    lightbox.qrcode();            //Lightbox-QR Code
    qrcode.webQRcode();           //QR Code-主體
    track.cancelTrack();          //加入追蹤-移除追蹤(Header追蹤列表)
    // footerAds.sliderModule();     //Footer Ads
    headerSearchVal.sendSearch(); //Header搜尋條件 (昀寬多加)
    //業務個人
    /*
    if(this.personalId !== undefined){
      //引入外部模組
      let personal = new Personal;

      personal.info();         //業務個人資訊
      lightbox.personal();     //Lightbox-業務個人資訊
      qrcode.personalQRcode(); //QR Code-業務個人
    }
    */
  } //commonModules() {

  //區域模組
  navModules() {
    //使用外部模組
    let iosFixed           = new IosFixed;
    let preloader          = new Preloader;
    let linkEffect         = new LinkEffect;
    let navSearch          = new NavSearch;
    let search             = new Search;
    let txtCrop            = new TxtCrop;
    let txtZoom            = new TxtZoom;
    let mapSearch          = new MapSearch;
    let acturlSearch       = new ActualSearch;
    let videoCover         = new VideoCover;
    let indexBanner        = new IndexBanner; //預定刪除
    let indexObjsSlide     = new IndexObjsSlider;
    let objsBannerImg      = new ObjsBannerImg; //預定刪除
    let parallaxBG         = new ParallaxBG;
    let lightbox           = new Lightbox;
    let qrcode             = new QRcode;
    let track              = new Track;
    let objListAJAX        = new ObjListAJAX;
    let mapRealtyDetail    = new MapRealtyDetail;
    let mapRealtySearch    = new MapRealtySearch;
    let vr720              = new VR720;
    let asideRealtyForm    = new AsideRealtyForm;
    let contactForm        = new ContactForm;
    let sameHeight         = new SameHeight;
    let tabs               = new Tabs;
    let toggleSlide        = new ToggleSlide;
    let sticky             = new Sticky;
    let textareaAutoHeight = new TextareaAutoHeight;
    let sendForm           = new SendForm;
    let speechForm         = new SpeechForm;
    let mortgage2          = new Mortgage2;
    let subscription       = new Subscription; //訂閱相關

    //判斷是否是空值
    if(this.nav == ''){
      this.nav = 'index';
    }

    switch(this.nav) {
      //首頁
      case 'index':
        this.commonModules();          //全域jQuery
        txtCrop.crop();                //文字裁切
        indexObjsSlide.sliderModule(); //觸控式物件
        track.toggleTrack();           //加入追蹤
        lightbox.map();                //Lightbox-Google Map
        lightbox.form();               //Lightbox-表單
        vr720.vr720();                 //VR720
        sameHeight.resultHeight();     //列表物件相同高度

        /*
        if(this.subsite === undefined || this.subsite === ''){
          if(this.personalId === undefined){
            indexBanner.sliderModule();      //輪播Banner-首頁
            videoCover.videoCover();         //首頁CM影片
            lightbox.video();                //Lightbox-Video
            parallaxBG.parallax();           //背景圖滾差
          }
        }
        */
        break;
      //買屋 / 租屋 / 新成屋
      case 'buy':
      case 'rent':
      case 'all_object':
      // case 'new':
        this.commonModules();     //全域jQuery
        track.toggleTrack();      //加入追蹤
        objListAJAX.ajaxSearch(); //AJAX 物件列表
        lightbox.map();           //Lightbox-Google Map
        lightbox.form();          //Lightbox-表單
        break;
      case 'buy_d':
      case 'rent_d':
      case 'all_object_d':
      // case 'new_d':
        this.commonModules();         //全域jQuery
        objsBannerImg.sliderModule(); //觸控式物件
        qrcode.realtyQRcode();        //QR Code
        lightbox.image();             //Lightbox-圖片
        lightbox.map();               //Lightbox-Google Map
        lightbox.form();              //Lightbox-表單
        track.toggleTrack();          //加入追蹤-其它推薦
        track.toggleAsideTrack();     //加入追蹤-側邊攔
        mapRealtyDetail.mapAPI();     //週邊地圖
        vr720.vr720();                //VR720
        // asideRealtyForm.checkForm();  //表單欄位判斷
        tabs.tabsToggle();            //Tabs 切換 DIV
        sticky.move();                //捲軸區塊定位
        sendForm.asideRealtyForm();   //Aside表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
        break;

       //買屋內的地圖  
      case 'ajax_realty_map':
        // this.commonModules();         //全域jQuery
        mapRealtyDetail.mapAPI();     //週邊地圖
        break;  

      //地圖找屋
      case 'map_search':
        iosFixed.metaViewport();  //iOS(iPad, iPhone) Meta Viewport 鎖定縮放拖曳
        preloader.loading();      //讀取頁面
        linkEffect.effect();      //頁面淡入淡出
        navSearch.navSearch();    //Rwd 導航列 & 搜尋列
        search.searchObj();       //Search
        lightbox.qrcode();        //Lightbox-QR Code
        qrcode.webQRcode();       //QR Code-主體
        track.cancelTrack();      //加入追蹤-移除追蹤(Header追蹤列表)
        mapSearch.selected();     //地圖找屋搜尋列
        mapRealtySearch.mapAPI(); //地圖找屋-Google Map
        break;


      //企業徵才 / 關於幸福家
      case 'recruitment':
      case 'about':
        this.commonModules(); //全域jQuery
        lightbox.image();     //Lightbox-圖片
        break;
        

      //文章專欄(業務個人) / 企業社會責任 / 幸福新鮮事 / 房仲達人 / 房市新聞 / 購屋指南 / 室內好設計 / 相關法規
      case 'personal_articles':
      case 'csr':
      case 'activity':
      case 'expert':
      case 'news':
      case 'guide':
      case 'design':
      case 'law':
        this.commonModules();      //全域jQuery
        txtCrop.crop();            //文字裁切
        sameHeight.resultHeight(); //列表物件相同高度
        break;
      case 'personal_articles_d':
      case 'csr_d':
      case 'activity_d':
      case 'expert_d':
      case 'news_d':
      case 'guide_d':
      case 'design_d':
      case 'law_d':
        this.commonModules();      //全域jQuery
        txtCrop.crop();            //文字裁切
        txtZoom.zoom();            //文字大小
        lightbox.image();          //Lightbox-圖片
        lightbox.map();            //Lightbox-Google Map
        lightbox.form();           //Lightbox-表單
        track.toggleAsideTrack();  //加入追蹤-側邊攔
        sameHeight.resultHeight(); //列表物件相同高度
        sticky.move();             //捲軸區塊定位
        break;
        


      //服務據點
      case 'stores':
        this.commonModules(); //全域jQuery
        lightbox.map();       //Lightbox-Google Map
        break;
      

      //本月之星 / 百萬超級戰將 / 龍虎榜超級戰將 / 優質專員
      /*
      case 'star':
      case 'star_m':
      case 'star_m_d':
      case 'star_dt':
      case 'star_dt_d':
      case 'personal':
        this.commonModules(); //全域jQuery
        break;
      */

      //實價登錄
      case 'actual_buy':
      case 'actual_rent':
        this.commonModules();      //全域jQuery
        acturlSearch.selected();   //實價登錄搜尋列
        toggleSlide.toggleSlide(); //Toggle Slide
        break;


      //客服信箱
      case 'contact':
        this.commonModules();            //全域jQuery
        textareaAutoHeight.autoHeight(); //文字欄位高度自動
        contactForm.checkForm();         //表單欄位判斷
        sendForm.contactForm();          //表單送出 - 客服信箱 (朝凱多加)
        break;
      

      //隱私權暨服務條款
      //隱私全條款 20230208 kai 改
      case 'private':
        this.commonModules(); //全域jQuery
        break;
     //隱私權暨服務條款
     //服務條款 20230208 kai 改
     case 'service_terms':
        this.commonModules(); //全域jQuery
        break;
      
      //房貸試算
      case 'formAlculate':
        this.commonModules(); //全域jQuery
        mortgage2.resultMortgage();
        // lightbox.form();  //Lightbox-表單
        break;

      //演講報名表
      /*
      case 'speech_form':
        this.commonModules(); //全域jQuery
        speechForm.form();
        break;
      */

      //app 我的訂閱條件表 - 增加
      case 'subscription_onsale_add':
        navSearch.navSearch();    //Rwd 導航列 & 搜尋列
        search.searchObj();       //Search
        mapSearch.selected();     //地圖找屋搜尋列
        subscription.addCondition();//訂閱儲存處理
        break;

      //app 我的訂閱條件表 - 編輯
      case 'subscription_onsale_edit':
        navSearch.navSearch();    //Rwd 導航列 & 搜尋列
        search.searchObj();       //Search
        mapSearch.selected();     //地圖找屋搜尋列
        subscription.editCondition(); //訂閱儲存處理
        break;

      //app 我的訂閱條件表 - 列表
      case 'subscription_onsale':
        navSearch.navSearch();    //Rwd 導航列 & 搜尋列
        search.searchObj();       //Search
        mapSearch.selected();     //地圖找屋搜尋列
        subscription.delCondition(); //訂閱刪除處理
        subscription.noticeChange(); //訂閱通知處理
        break;  

      case 'subscription_onsale_objs':
        subscription.jsonLoading(); //下拉ajax
        break;
      case 'subscription_onsale_objs_priceChange':
        // subscription.jsonLoading(); //下拉ajax
        break;

      //我的訂閱-地圖列表
      case 'subscription_map_objs':
        subscription.jsonLoading(); //下拉ajax
        break;
      case 'subscription_map':
        subscription.noticeChange(); //訂閱通知處理
        subscription.delCondition(); //訂閱刪除處理
        break;  

    } //switch(this.nav) {

    //子網站
    /*
    switch(this.subsite) {
      //新建案
      case 'new_realty':
      case 'new_realty_years':
      case 'new_realty_d':
        //全域模組
        this.commonModules();
        //QR Code
        qrcode.realtyQRcode();
        //加入追蹤-側邊攔
        track.toggleAsideTrack();
        //Lightbox-圖片
        lightbox.image();
         //Lightbox-表單
        lightbox.form();
        //使用外部模組
        let newRealty= new NewRealty;
        newRealty.publicModules();
        break;

      //智慧房產
      case 'line_ai':
        //全域模組
        this.commonModules();
        //使用外部模組
        let lineAI = new LineAI;
        lineAI.publicModules();
        break;
    }
    */
  }
  //整合
  publicModules() {
    this.navModules();
  }
}




//輸出
let navController = new NavController;
navController.publicModules();


// WEBPACK FOOTER //
// ./js_new/app.js